import React, { type ComponentType } from "react";
import { SiteNav, SiteStickyFooter } from "./SiteChrome.js";
import SiteBackground from "./SiteBackground.js";
import { AD_MODE } from "../lib/site-config.js";

interface GameRoutePageProps {
  title: string;
  description: string;
  GameComponent: ComponentType<{ hideTitle?: boolean }>;
}

export default function GameRoutePage({ title, description, GameComponent }: GameRoutePageProps) {
  return (
    <>
      <SiteBackground />

      <div className="site-wrap">
        <SiteNav />

        <header className="hero">
          <div className="hero-copy">
            <span className="hero-eyebrow">// MisterGames</span>
            <h1><span className="hero-accent">{title}</span></h1>
            <p>{description}</p>
            <div className="hero-ctas">
              <a href="/" className="cta cta--ghost">← All Games</a>
            </div>
          </div>
          <div className="hero-art">
            {[
              { emoji: "🎮", bg: "linear-gradient(160deg,#001428,#002a50)", glow: "#00b4ff" },
              { emoji: "🕹️", bg: "linear-gradient(160deg,#001a20,#003040)", glow: "#00ffea" },
              { emoji: "⚡",  bg: "linear-gradient(160deg,#101828,#1a2a40)", glow: "rgba(255,255,255,0.8)" },
            ].map((m) => (
              <div key={m.emoji} style={{
                width: 100, height: 100, borderRadius: 24,
                background: m.bg, border: `2px solid ${m.glow}`,
                boxShadow: `0 0 20px ${m.glow}, 0 0 60px ${m.glow}40`,
                display: "flex", alignItems: "center", justifyContent: "center", fontSize: "2.5rem",
              }}>{m.emoji}</div>
            ))}
          </div>
        </header>

        <GameComponent hideTitle />

        <SiteStickyFooter adMode={AD_MODE} />
      </div>
    </>
  );
}
